<template>
  <a-form-model class="form" :model="form" ref="editForm" :rules="rules">
    <a-form-model-item label="大标题" prop="title">
      <a-input v-model="form.title" placeholder="嘉宾列表大标题"></a-input>
    </a-form-model-item>
    <a-form-model-item label="嘉宾列表">
      <drag-zone class="item-list" :list="items">
        <template v-slot="{ item, index }">
          <div class="guest-item">
            <div
              class="guest-img"
              :style="{
                backgroundImage: `url(${item.speaker_avatar || item.avatar}`,
              }"
            ></div>
            <div class="guest-info">
              <div class="guest-title">{{ item.speaker || item.name }}</div>
              <div class="guest-desc">
                {{ item.speaker_org || item.company }}
              </div>
            </div>
            <div class="guest-btn">
              <div class="el-icon-edit-outline" @click="editGuest(index)"></div>
              <div class="el-icon-delete" @click="remove(index)"></div>
            </div>
          </div>
        </template>
      </drag-zone>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加嘉宾</div>
      </div>
    </a-form-model-item>
    <template v-if="form.more">
      <a-form-model-item label="卡片“更多”文字">
        <a-input v-model="form.more.title"></a-input>
      </a-form-model-item>
      <a-form-model-item label="卡片“更多”链接">
        <a-input v-model="form.more.url"></a-input>
      </a-form-model-item>
    </template>
    <a-form-model-item label="标题加粗">
      <a-switch v-model="form.bold"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="卡片分割线">
      <a-switch v-model="form.itemLine"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="标题分割线">
      <a-switch v-model="form.topLine"></a-switch>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        v-model="form.backgroundColor"
        class="color-picker top shadow"
      ></colorPicker>
    </a-form-model-item>
    <a-form-model-item label="是否在首页显示">
      <a-switch v-model="form.isShow"></a-switch>
    </a-form-model-item>
    <a-modal
      title="嘉宾配置"
      width="300px"
      :visible.sync="ds"
      @ok="confirmGuest"
      @cancel="hideDialog"
    >
      <a-form-model :model="guest" ref="guestForm" :rules="guestRules">
        <a-form-model-item label="嘉宾来源" prop="type">
          <a-radio-group v-model="guest.type">
            <a-radio :value="1">从日程中选</a-radio>
            <a-radio :value="2">手动输入</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="选择嘉宾" prop="item" v-if="guest.type == 1">
          <a-select v-model="guest.item" placeholder="点击选择嘉宾">
            <a-select-option v-for="item in guestList" :key="item.id">
              {{ item.speaker }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <template v-else>
          <a-form-model-item label="嘉宾姓名" prop="name">
            <a-input v-model="guest.name" placeholder="嘉宾姓名"></a-input>
          </a-form-model-item>
          <a-form-model-item label="嘉宾头像" prop="avatar">
            <cl-upload v-model="guest.avatar"></cl-upload>
          </a-form-model-item>
          <a-form-model-item label="所属单位" prop="company">
            <a-input v-model="guest.company" placeholder="所属单位"></a-input>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
  </a-form-model>
</template>

<script>
import clUpload from "../cl-upload";
import dragZone from "../drag-zone";
import { clone, randomString } from "../../common/js/tool";

export default {
  name: "guest-edit",
  components: {
    dragZone,
    clUpload,
  },
  props: {
    value: Object,
  },
  inject: ["build"],
  data() {
    return {
      form: {},
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      items: [],
      index: null,
      ds: false,
      guest: {},
      guestList: [],
      guestRules: {
        type: [
          { required: true, message: "请选择嘉宾来源", trigger: "change" },
        ],
        item: [{ required: true, message: "请选择嘉宾", trigger: "change" }],
        name: [{ required: true, message: "请输入嘉宾姓名", trigger: "blur" }],
        company: [
          { required: true, message: "请输入所属单位", trigger: "blur" },
        ],
        avatar: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value && value.length > 0) {
                callback();
              } else {
                callback(new Error("请上传嘉宾头像"));
              }
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
    /* console.log(this.build,this.setSelect) */
    //获取日程里的嘉宾，存入guestList
    this.getGuest();
  },
  methods: {
    hideDialog() {
      this.ds = false;
      this.index = null;
    },
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        temp.list.forEach((item) => {
          if (!item.key) {
            item.key = `icon_${randomString(6)}`;
          }
        });
        this.items = temp.list;
        delete temp.list;
        this.form = temp;
      }
    },
    addItem() {
      this.ds = true;
      this.guest = { type: 1 };
    },
    editGuest(index) {
      let item = this.items[index];
      let guest = clone(item);
      if (!guest.type) {
        guest.type = guest.speaker ? 1 : 2;
      }
      this.guest = guest;
      this.index = index;
      this.ds = true;
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      temp.list = clone(this.items);
      this.$emit("change", temp);
    },
    confirmGuest() {
      this.$refs.guestForm.validate((flag) => {
        if (flag) {
          let guest = this.guest;
          let item;
          if (guest.type == 1) {
            let temp = guest.item;
            item = {
              speaker: temp.speaker,
              speaker_avatar: temp.speaker_avatar,
              speaker_org: temp.speaker_org,
            };
          } else {
            item = {
              name: guest.name,
              avatar: guest.avatar,
              company: guest.company,
            };
          }
          item.type = guest.type;
          let items = this.items;
          if (guest.key) {
            item.key = guest.key;
            this.$set(items, this.index, item);
          } else {
            item.key = `icon_${randomString(6)}`;
            items.push(item);
          }
          this.hideDialog();
        }
      });
    },
    getGuest() {
      this.$axios(`/activity/activity?filter[id]=${this.build.id}`).then(
        (res) => {
          /* console.log(res) */
          let sche = res.data[0].schedule;
          let areaList = [];
          let forumList = [];
          let lectureList = [];
          //console.log(sche)
          sche.forEach((item) => {
            areaList.push(item.area);
          });
          //console.log(areaList)
          areaList.forEach((item) => {
            if (item instanceof Array) {
              item.forEach((i) => {
                forumList.push(i.forum);
              });
            } else {
              forumList.push(item.forum);
            }
          });
          //console.log(forumList)
          forumList.forEach((item) => {
            if (item instanceof Array) {
              item.forEach((i) => {
                lectureList.push(i.lecture);
              });
            } else {
              lectureList.push(item.lecture);
            }
          });
          //console.log(lectureList)
          this.guestList = [].concat(...lectureList);
          //console.log(this.guestList)
        }
      );
    },
    validate() {
      let msg = null;
      if (!this.form.title) {
        msg = "请输入嘉宾列表大标题";
      }
      return msg;
    },
  },
};
</script>

<style scoped lang="less">
.guest-item {
  display: flex;
  position: relative;
  padding: 10px;
  background-color: var(--back-light-color);
  border-bottom: 1px solid var(--back-white-color);
  &:hover {
    .guest-btn {
      display: flex;
    }
  }
}
.guest-img {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  background: center no-repeat;
  background-size: cover;
}
.guest-info {
  flex: 1;
  margin: 0 5px;
  line-height: 1;
}
.guest-desc {
  margin-top: 12px;
  color: var(--tip-font-color);
}

.guest-detail {
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-font-color);
}
.guest-btn {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 0 10px;
  width: 40px;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.8)
  );
  font-size: 20px;
  color: var(--text-font-color);
  cursor: pointer;
  .el-icon-delete {
    margin-top: 10px;
  }
}

.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
